import React from 'react'
import ClipLoader from 'react-spinners/ClipLoader'

import styles from './style.module.scss'
import clsx from 'clsx'

export enum SpinnerTheme {
    Light = '#FFFFFF',
    Dark = '#202020',
}

interface Props {
    theme?: SpinnerTheme
    size?: number
}

const XLoadingIndicator: React.FC<Props> = (props: Props) => {
    const defaultSize = 20
    const defaultColor = SpinnerTheme.Dark

    return (
        <div className={clsx(styles.loadingIndicator)}>
            <ClipLoader size={props.size || defaultSize} color={props.theme || defaultColor} loading={true} />
        </div>
    )
}

export default XLoadingIndicator
